import { render, staticRenderFns } from "./typeList.vue?vue&type=template&id=7c63f4a4&scoped=true"
import script from "./typeList.vue?vue&type=script&lang=js"
export * from "./typeList.vue?vue&type=script&lang=js"
import style0 from "./typeList.vue?vue&type=style&index=0&id=7c63f4a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c63f4a4",
  null
  
)

export default component.exports